import React, { useState,useEffect } from "react";
import styles from "./sidebar.module.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link,withRouter } from "react-router-dom";


const Sidebar = (props) => {
  const [select, setSelect] = useState(0);
  const params=props.location?.pathname;
  useEffect(()=>{
    if(params==='/configuration'){
      setSelect(0)
    }
    else if(params==='/configuration/department'){
      setSelect(1)
    }
    else if(params==='/configuration/program-type'){
      setSelect(2)
    }
    else if(params==='/configuration/program-mode'){
      setSelect(3)
    }
    else if(params==='/configuration/program'){
      setSelect(4)
    }
    else if(params==='/configuration/users'){
      setSelect(5)
    }
    else if(params==='/configuration/program-outcome'){
      setSelect(6)
    }
    else if(params==='/configuration/generic-program-outcomes'){
      setSelect(7)
    }
    else if(params==='/configuration/course-type'){
      setSelect(8)
    }
    else if(params==='/configuration/delivery-method'){
      setSelect(9)
    }
    else if(params==='/configuration/lab-category'){
      setSelect(10)
    }
    else if(params==='/configuration/blooms-domain'){
      setSelect(11)
    }
    else if(params==='/configuration/blooms-level'){
      setSelect(12)
    }
    else if(params==='/configuration/map-level-weightage'){
      setSelect(13)
    }
  },[params])

  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={select}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{ style: { background: "transparent" } }}
      >
        <Tab
          component={Link}
          to="/configuration"
          label="Organization"
          style={{ minWidth: "100%" }}
          className={select == 0 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(0)}
        />
        <Tab
          component={Link}
          to="/configuration/department"
          label="Department"
          style={{ minWidth: "100%" }}
          className={select == 1 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(1)}
        />
        <Tab
          component={Link}
          to="/configuration/program-type"
          label="Program Type"
          style={{ minWidth: "100%" }}
          className={select == 2 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(2)}
        />
        <Tab
          component={Link}
          to="/configuration/program-mode"
          label="Program Mode"
          style={{ minWidth: "100%" }}
          className={select == 3 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(3)}
        />
        <Tab
          component={Link}
          to="/configuration/program"
          label="Program"
          style={{ minWidth: "100%" }}
          className={select == 4 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(4)}
        />
        <Tab
          component={Link}
          to="/configuration/users"
          label="Users"
          style={{ minWidth: "100%" }}
          className={select == 5 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(5)}
        />
        <Tab
          component={Link}
          to="/configuration/program-outcome"
          label="Program Outcome (PO) Type"
          style={{ minWidth: "100%" }}
          className={select == 6 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(6)}
        />
        {/* <Tab
          component={Link}
          to="/configuration/generic-program-outcomes"
          label="Generic Program Outcomes (POs)"
          style={{ minWidth: "100%" }}
          className={select == 7 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(7)}
        /> */}
        <Tab
          component={Link}
          to="/configuration/course-type"
          label="Course Type"
          style={{ minWidth: "100%" }}
          className={select == 8 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(8)}
        />
        <Tab
          component={Link}
          to="/configuration/delivery-method"
          label="Delivery Method"
          style={{ minWidth: "100%" }}
          className={select == 9 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(9)}
        />
        <Tab
          component={Link}
          to="/configuration/lab-category"
          label="Lab Category"
          style={{ minWidth: "100%" }}
          className={select == 10 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(10)}
        />
        <Tab
          component={Link}
          to="/configuration/blooms-domain"
          label="Bloom's Domain"
          style={{ minWidth: "100%" }}
          className={select == 11 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(11)}
        />
        <Tab
          component={Link}
          to="/configuration/blooms-level"
          label="Bloom's Level"
          style={{ minWidth: "100%" }}
          className={select == 12 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(12)}
        />
        <Tab
          component={Link}
          to="/configuration/map-level-weightage"
          label="Map Level Weightage"
          style={{ minWidth: "100%" }}
          className={select == 13 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(13)}
        />
      </Tabs>
    </>
  );
};

export default withRouter(Sidebar);
